//React Components and Hooks
//Material UI Components
import Chip from "@mui/material/Chip";
//Material UI functions
import { useTheme } from "@mui/styles";
import React from "react";
import { getChipVariant } from '../../utils/chipStyles';

const SuccessChip = (props) => {
  const theme = useTheme();
  const chipProps = getChipVariant('success', theme);
  
  return (
    <Chip 
      label={props.text} 
      {...chipProps}
      size="small" 
    />
  );
};
export default SuccessChip;
